import { useTranslation } from "react-i18next";
import {
  ChallengeCardWrapper,
  ChallengeHeader,
  ChallengeTimer,
} from "./ChallengeUtils";
import { ChallengeInfoProps } from "@/pages/challenges/ChallengeInfo";

export const ChallengeStartedCard = ({ deadline }: ChallengeInfoProps) => {
  const { t } = useTranslation();

  return (
    <ChallengeCardWrapper>
      <div className="flex items-start justify-between">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <ChallengeHeader text={t("challenge.challenge_started")} />
          </div>
        </div>
      </div>
      {deadline && <ChallengeTimer deadline={deadline} />}
    </ChallengeCardWrapper>
  );
};
